import { oc } from '@orpc/contract';
import { cloneTemplateVersionInputSchema, templateDetailSchema } from '../schemas/templates.schemas.js';
/** A new template whose first DRAFT copies the values of any version of any template. */
export const cloneTemplateVersionContract = oc
    .route({
    method: 'POST',
    path: '/templates/versions/{fromVersionId}/clone',
    tags: ['Templates'],
    summary: 'Clone a template version into a new template',
})
    .input(cloneTemplateVersionInputSchema)
    .output(templateDetailSchema);
//# sourceMappingURL=clone-template-version.contract.js.map